export default __webpack_public_path__ + "static/banner-why-you-should-spend-valentines-day-alone-0c6e373ae7154491459f7707c6562075.jpg";